import { createContext } from 'react';
export const FormStoreContext = createContext(null);
//# sourceMappingURL=FormStoreContext.js.map